<template>
    <auth-layout id="password-forget-page" class="h-100">
        <div class="col-12 col-lg-8 col-xl-6">
            <div class="row py-4">
                <div class="col-12">
                    <h2>{{$t('global.verification.title')}}</h2>
                </div>
            </div>

            <section id="login-form">
                <div class="row">
                    <div class="col-12">
                        <div v-if="!mailSend" class="alert alert-warning p-3">
                            {{$t('global.verification.text')}}
                        </div>
                        <div v-if="mailSend" class="alert alert-success p-3">
                            {{$t('global.verification.text.mail_again')}}
                        </div>
                    </div>

                    <div class="col-12 d-flex justify-content-end p-0">
                        <div class="col-12 col-md-6 d-flex justify-content-end pt-3">
                            <b-button variant="primary" @click="handleResend" :disabled="mailSend" block>
                                {{$t('global.verification.button.send_email')}}
                            </b-button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </auth-layout>
</template>

<script>
import AuthLayout from "../../layouts/AuthLayout.vue";
import { BButton } from "bootstrap-vue";
export default {
    components: {
        AuthLayout,
        BButton
    },
    data() {
        return {
            mailSend: false,
        }
    },
    methods: {
        handleResend() {
            this.mailSend = true;

            this.$axios.get('/sanctum/csrf-cookie').then(() => {
                this.$axios.post('api/resend_verification');
            })
        }
    },
    head: {
        title: function () {
            return {
                inner: this.$root.whitelabel.state.settings.meta_title,
                complement: this.$t('meta.auth.notVerified.title')
            }
        },
        meta: function () {
            return [
                { name: 'description', content: this.$t('meta.auth.notVerified.description') }
            ]
        }
    }
}
</script>
